import React, { Component } from "react";
import { QuestionTable } from "@learningblocks/protocol-components/lib/QuestionTable";

export class QuestionTableAdapter extends Component {
  render() {
    return (
      <div>
        <QuestionTable
          {...this.props}
          onCellChange={this.props.questionTableCellUpdate}
          submitAnswer={this.props.questionTableSubmit}
          //resetAnswer = {this.onReset}
        />
      </div>
    );
  }
}
